import { ApiError } from '@nucleus-commerce/api-client/transport';

/** Deleting a method that unpaid orders still use answers 409 RESOURCE_IN_USE. */
export function paymentMethodDeleteErrorKey(error: unknown): string | null {
  if (!(error instanceof ApiError)) return null;
  return error.code === 'RESOURCE_IN_USE' || error.kind === 'conflict'
    ? 'paymentMethods:errors.inUse'
    : null;
}

export interface PaymentMethodErrorTarget {
  field: 'key' | 'fee' | 'minOrder' | 'maxOrder' | 'root.server';
  key: string;
  values?: Record<string, unknown>;
}

/**
 * Where a save failure lands when the backend sent no usable `details`: a duplicate key on the
 * key field, a currency mismatch (meta.currency) on the form.
 */
export function paymentMethodErrorTarget(error: unknown): PaymentMethodErrorTarget | null {
  if (!(error instanceof ApiError)) return null;
  if (error.code === 'ALREADY_EXISTS')
    return { field: 'key', key: 'paymentMethods:errors.keyTaken' };
  if (typeof error.meta.currency === 'string') {
    return {
      field: 'root.server',
      key: 'paymentMethods:errors.currency',
      values: { currency: error.meta.currency },
    };
  }
  return null;
}
